import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { Label, Stack, Text, mergeStyleSets, Image } from '@fluentui/react';
import { ExternalRatingSummary } from './externalRatingSummary';
import ratingStar from '@shared/images/RatingStarFilled.svg';
import { getTotalExternalRatingSummariesInfo } from '@shared/utils/reviewsUtils';
import * as PropTypes from 'prop-types';
const contentStyles = mergeStyleSets({
    ratingDisplayWrapper: {
        marginTop: 16
    },
    externalRatingSummariesAverage: [
        'externalRatingSummariesAverage',
        {
            '& .externalRatingSummariesNumOfStars': {
                padding: 0
            }
        }
    ]
});
export const ExternalRatingSummaries = ({ externalRatingSummaries = [] }, context)=>{
    const rawRatingSummaries = externalRatingSummaries === null || externalRatingSummaries === void 0 ? void 0 : externalRatingSummaries.map((externalRatingSummary)=>externalRatingSummary.ratingSummary);
    const externalSummariesInfo = getTotalExternalRatingSummariesInfo(rawRatingSummaries);
    return /*#__PURE__*/ _jsxs("div", {
        className: "externalRatingSummariesContainer",
        children: [
            /*#__PURE__*/ _jsx(Stack, {
                tokens: {
                    childrenGap: 2,
                    padding: 1
                },
                children: externalRatingSummaries === null || externalRatingSummaries === void 0 ? void 0 : externalRatingSummaries.map((externalRatingSummary)=>/*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsx(ExternalRatingSummary, {
                            ratingSummary: externalRatingSummary.ratingSummary,
                            image: externalRatingSummary.image,
                            showImage: true,
                            source: externalRatingSummary.ratingSummary.Source
                        }, `${externalRatingSummary.ratingSummary.Source}-ExternalRatingSummary`)
                    }))
            }),
            /*#__PURE__*/ _jsx("div", {
                children: externalRatingSummaries && /*#__PURE__*/ _jsx(Stack, {
                    horizontal: true,
                    className: contentStyles.ratingDisplayWrapper,
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        horizontal: true,
                        className: contentStyles.externalRatingSummariesAverage,
                        children: [
                            /*#__PURE__*/ _jsx(Image, {
                                className: "externalRatingSummariesStar",
                                src: ratingStar,
                                alt: context.loc('Rating_Star_Image_Alt', 'Rating star')
                            }),
                            /*#__PURE__*/ _jsx(Label, {
                                className: "externalRatingSummariesNumOfStars",
                                children: externalSummariesInfo.averageRatings.toFixed(1)
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                className: "externalRatingSummariesNumOfRatingText",
                                variant: "mediumPlus",
                                children: [
                                    "(",
                                    context.locParams('Global_Loc_NumOfRatingsLower', [
                                        externalSummariesInfo.totalRatings.toString()
                                    ]),
                                    ")"
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
ExternalRatingSummaries.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
